// 控制台debug开关配置

// 缓存属性名
const DEBUG_ATTRIBUTE = '__st_debug__'
// 属性key
export type DEBUG_KEYS = 'debug' | 'bridge'

// 获取缓存
const cacheDebugKey = localStorage.getItem(DEBUG_ATTRIBUTE)

/**
 * 启用debug日志打印
 */
export const isDebugMode = (key: DEBUG_KEYS) => {
  // 优先取运行时
  const currentKey = window[DEBUG_ATTRIBUTE] || cacheDebugKey
  // debug模式下，所有日志都打印
  if (currentKey === 'debug') return true

  return currentKey === key
}
